import * as React from "react";
import { styled } from "@mui/material/styles";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import Collapse from "@mui/material/Collapse";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { red } from "@mui/material/colors";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MoreVertIcon from "@mui/icons-material/MoreVert";

export const NewsShow = ({ load, setload }) => {
  const [expanded, setExpanded] = React.useState(false);
  const ExpandMore = styled((props) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
  })(({ theme, expand }) => ({
    transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
    }),
  }));

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };
  return (
    <>
      <br />
      {load?.map((e, index) => {
      
        return (
          <span key={index}>
            <Card>
              <CardHeader
                avatar={
                  <Avatar sx={{ bgcolor: red[600] }} aria-label="recipe">
                    News
                  </Avatar>
                }
                action={
                  <IconButton aria-label="settings">
                    <MoreVertIcon />
                  </IconButton>
                }
                title={e?.title}
                subheader={e?.pubDate}
              />
              {e?.image_url?(<CardMedia
                component="img"
                height="350"
                image={e?.image_url}
                alt="img"
              />):null}
              <CardContent>
                <Typography variant="body2" color="text.secondary">
                  {e?.description}
                </Typography>
              </CardContent>
              <CardActions disableSpacing>
                <IconButton aria-label="add to favorites">
                  <FavoriteIcon />
                </IconButton>

                <ExpandMore
                  expand={expanded}
                  onClick={handleExpandClick}
                  aria-expanded={expanded}
                  aria-label="show more"
                >
                  <ExpandMoreIcon />
                </ExpandMore>
              </CardActions>
              <Collapse in={expanded} timeout="auto" unmountOnExit>
                <CardContent>
                 
                  <Typography paragraph>
                    Click below link to read all info. about this
                  </Typography>
                  <Typography paragraph>
                    <a href={e?.link}>
                      <button className="btn btn-primary">Click on Me</button>
                    </a>
                  </Typography>
                </CardContent>
              </Collapse>
            </Card>
            <br />
          </span>
        );
      })}
    </>
  );
};
